module.exports = "/assets/data/8397e3520be06ffe14601b8893eedea7-GU32.data.json";